"use strict";

exports.__esModule = true;
exports.StyledLabel = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledLabel = _styledComponents.default.label`
    display: ${props => props.hasOwnProperty('inline') ? 'flex' : 'block'};
    ${props => props.hasOwnProperty('inline') ? 'align-items: center;' : ''} 
    vertical-align: bottom;
    margin-bottom: ${props => props.hasOwnProperty('inline') ? '0' : props.theme.space[4]};
    color: ${({
  theme
}) => theme.colors.label.text};
`;
exports.StyledLabel = StyledLabel;